import * as React from 'react'
import * as styles from './Header.module.less'

export const SiteHeader: React.FC = (props) => {
    const { children } = props
	return <div className={`${styles.siteHeader} siteHeader`}>{children}</div>
}
